import { render, staticRenderFns } from "./StatusEdit.vue?vue&type=template&id=fbbaf3ac"
import script from "./StatusEdit.vue?vue&type=script&lang=js"
export * from "./StatusEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports